import { ActionContext, Module } from "vuex";
import { RootState } from "@/store/index";
import { DocumentClassification, documentClassificationApi } from "@/api/documentClassification";

export interface DocumentClassificationState {
  documentClassifications: DocumentClassification[];
}

const documentClassificationModule: Module<DocumentClassificationState, RootState> = {
  namespaced: true,
  state: () =>
    ({
      documentClassifications: [] as DocumentClassification[]
    } as DocumentClassificationState),
  mutations: {
    setDocumentClassifications(
      state: DocumentClassificationState,
      documentClassifications: DocumentClassification[]
    ): void {
      state.documentClassifications = documentClassifications;
    }
  },
  actions: {
    async listAll(
      context: ActionContext<DocumentClassificationState, RootState>
    ): Promise<void> {
      if (
        !context.state.documentClassifications ||
        context.state.documentClassifications.length === 0
      ) {
        context.commit(
          "setDocumentClassifications",
          await documentClassificationApi.list()
        );
      }
    },
    async add(
      context: ActionContext<DocumentClassificationState, RootState>,
      documentClassification: DocumentClassification
    ): Promise<void> {
      await documentClassificationApi.add(documentClassification);
      context.commit(
        "setDocumentClassifications",
        await documentClassificationApi.list()
      );
    },
    async edit(
      context: ActionContext<DocumentClassificationState, RootState>,
      documentClassification: DocumentClassification
    ): Promise<void> {
      if (documentClassification.id) {
        await documentClassificationApi.edit(documentClassification);
        context.commit(
          "setDocumentClassifications",
          await documentClassificationApi.list()
        );
      }
    },
    async remove(
      context: ActionContext<DocumentClassificationState, RootState>,
      documentClassification: DocumentClassification
    ): Promise<void> {
      if (documentClassification.id) {
        await documentClassificationApi.delete(documentClassification);
        context.commit(
          "setDocumentClassifications",
          await documentClassificationApi.list()
        );
      }
    }
  }
};

export default documentClassificationModule;
